import ExternalSchoolIntegration from "../domain/data/ExternalSchoolIntegration";
import Organization from "../domain/entities/Organization";
import Signatory from "../domain/entities/Signatory";
import Student from "../domain/entities/Student";

export default class APIExternalSchoolRepository implements ExternalSchoolIntegration{
    async getGrades(organization: Organization, schoolYearStart: number, schoolYearEnd: number): Promise<string[]> {
        const token = sessionStorage.getItem('oauth2-clever-access_token');
        if (token){
            //fetch(`https://api.clever.com/v3.0/terms${new URLSearchParams([['','value'], ['bar','2']])}`, {
            const response = await fetch(`https://api.clever.com/v3.0/terms`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });

            if (!response.ok) {
                const message = `An error has occured: ${response.status}`;
                throw new Error(message);
            }
            
            const terms = await response.json(); 
            return terms;
        }
        throw new Error("Token not found");
    }
    getStudents(organization: Organization, schoolYearStart: number, schoolYearEnd: number, grade: string): Promise<Student[]> {
        throw new Error("Method not implemented.");
    }
    getStudentSignatories(organization: Organization, schoolYearStart: number, schoolYearEnd: number, grade: string, student: Student): Promise<Signatory[]> {
        throw new Error("Method not implemented.");
    }

    async getSchools(cleverToken: string) {
    
        if (!cleverToken) {
            throw new Error("Token not found");
        }
    
        const baseUrl = `https://api.clever.com/v3.0/schools`;
        let allSchools: any[] = [];
        let nextUrl: string | null = baseUrl;
    
        try {
            while (nextUrl) {
                const response = await fetch(nextUrl, {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${cleverToken}`
                    }
                });
    
                if (!response.ok) {
                    const message = `An error has occurred: ${response.status}`;
                    throw new Error(message);
                }
    
                const jsonResponse = await response.json();
                const schools = jsonResponse.data.map((item: { data: any }) => item.data);
                allSchools = [...allSchools, ...schools];
                const nextLink = jsonResponse.links.find((link: { rel: string }) => link.rel === 'next');
                nextUrl = nextLink ? `https://api.clever.com${nextLink.uri}` : null;
            }
    
            return allSchools;
    
        } catch (error) {
            console.error("Error fetching schools:", error);
            throw error;
        }
    }

    async getSections(cleverToken: string, schoolId: string) {

        if (!cleverToken) {
            throw new Error("Token not found");
        }

        const baseUrl = `https://api.clever.com/v3.0/schools/${schoolId}/sections`;
        let allSections: any[] = [];
        let nextUrl: string | null = baseUrl;

        try {
            while (nextUrl) {
              const response = await fetch(nextUrl, {
                method: 'GET',
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${cleverToken}`
                }
              });
        
              if (!response.ok) {
                const message = `An error has occurred: ${response.status}`;
                throw new Error(message);
              }
        
              const jsonResponse = await response.json();
              allSections = [...allSections, ...jsonResponse.data];
              const nextLink = jsonResponse.links.find((link: { rel: string }) => link.rel === 'next');
              nextUrl = nextLink ? `https://api.clever.com${nextLink.uri}` : null;
            }
        
            return allSections;
        
        } catch (error) {
        console.error("Error fetching sections:", error);
        throw error;
        }
    }

    async getStudent(cleverToken: string, studentId: string) {
        const token = 'ebe6e73da8f6fb1b4bc45ad002d94b93a207e8ec';
        if(token){
            const response = await fetch(`https://api.clever.com/v3.0/users/` + studentId, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });

            if (!response.ok) {
                const message = `An error has occured: ${response.status}`;
                throw new Error(message);
            }
            const studentData = await response.json();

            const { data: student } = studentData;

            return student;
        }
    }

    async getContacts(cleverToken: string, studentId: string) {
        const token = 'ebe6e73da8f6fb1b4bc45ad002d94b93a207e8ec';
        if(token){
            const response = await fetch(`https://api.clever.com/v3.0/users/` + studentId+ `/myContacts`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });
            if (!response.ok) {
                const message = `An error has occured: ${response.status}`;
                throw new Error(message);
            }
            const contactsData = await response.json();

            const { data: contacts } = contactsData;

            return contacts;
        }
    }

    async getStaff(cleverToken: string, schoolId: string): Promise<any[]> {
    
        const baseUrl = `https://api.clever.com/v3.0/schools/${schoolId}/users`;
        let allStaff: any[] = [];
        let nextUrl: string | null = baseUrl;
    
        try {
            while (nextUrl) {
                const response = await fetch(nextUrl, {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${cleverToken}`
                    }
                });
    
                if (!response.ok) {
                    const message = `An error has occurred: ${response.status}`;
                    throw new Error(message);
                }
    
                const jsonResponse = await response.json();
                
                const staff = jsonResponse.data
                    .map((item: { data: any }) => item.data)
                    .filter((item: any) => item.roles?.staff);
                
                if (staff.length < jsonResponse.data.length) {
                    allStaff = [...allStaff, ...staff];
                    break;
                }

                allStaff = [...allStaff, ...staff];

                const nextLink = jsonResponse.links.find((link: { rel: string }) => link.rel === 'next');
                nextUrl = nextLink ? `https://api.clever.com${nextLink.uri}` : null;
            }
    
            return allStaff;
        } catch (error) {
            console.error("Error fetching staff:", error);
            throw error;
        }
    }

    /*
    objectToQuery (object: any) {
        return new URLSearchParams(object).toString();
    }

    formatExchangeCodeForTokenServerURL = (serverURL: string, clientId: string, code: string, redirectURI: string) => {
        return `${serverURL}?${this.objectToQuery({
            client_id: clientId,
            code,
            redirect_uri: redirectURI,
        })}`;
    };
    */

    static async getToken(code: string, clientId: string, redirectURI: string): Promise<Response>{
	    return fetch(`/api/clever/tokens`, {
			method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                code,
                "grant_type": "authorization_code",
                "redirect_uri": redirectURI
            })
		});
    }

    async getToken(code: string, clientId: string, redirectURI: string): Promise<Response> {
        return APIExternalSchoolRepository.getToken(code, clientId, redirectURI);
    }

}